import { useEffect } from "react";
const useBodyClassToggler = ({
  triggerer,
  className = null,
  htmlClassName = null,
  toTop = false
}) => {
  useEffect(() => {
    if (triggerer.includes(true)) {
      !!className && document.body.classList.add(className);
      !!htmlClassName && document.documentElement.classList.add(htmlClassName);
      if (toTop) {
        window.scroll({ top: 0, left: 0 });
      }
    } else {
      !!className && document.body.classList.remove(className);
      !!htmlClassName && document.documentElement.classList.remove(htmlClassName);
    }
    return () => {
      !!className && document.body.classList.remove(className);
      !!htmlClassName && document.documentElement.classList.remove(htmlClassName);
    };
  }, [...triggerer]);
};
export {
  useBodyClassToggler
};
